/** @jsx jsx */
import { useState, Fragment } from 'react'
import validator from 'validator'
import { css, jsx } from '@emotion/core'
import { Button, Input } from '@livechat/design-system'
import addIcon from '../../assets/images/add.png'

const containerCss = css`
  margin-top: 5px;
  display: flex;
  align-items: center;

  .lc-btn {
    height: 36px;

    > div {
      height: 24px;
    }
  }

  .add-answer {
    width: 24px;
  }
`

const NextAnswer = ({ update, answers, submitted, index }) => {
  const [newAnswer, setNewAnswer] = useState('')
  const [newAnswerError, setNewAnswerError] = useState('')

  const addAnswer = () => {
    if (
      newAnswer &&
      !validator.isEmpty(newAnswer, { ignore_whitespace: true })
    ) {
      if (newAnswer.length < 100) {
        setNewAnswer('')
        setNewAnswerError('')
        update('answers', [...answers, newAnswer])
      } else {
        setNewAnswerError('Answer is to long.')
      }
    }
  }

  const answersError = submitted
    ? answers.length < 2
      ? 'Enter at least 2 answers.'
      : undefined
    : undefined

  const onEnterSubmit = (e) => {
    if (e.keyCode === 13) {
      addAnswer()
    }
  }

  return (
    <Fragment>
      <div css={containerCss}>
        <Input
          value={newAnswer}
          id="input-field-answer"
          placeholder="Type an answer"
          onChange={(e) => {
            setNewAnswer(e.target.value)
          }}
          onKeyDown={onEnterSubmit}
          error={answersError || newAnswerError || undefined}
          data-cy={`field-${index}-add-answer-input`}
        />
        <Button
          type="ghost"
          onClick={addAnswer}
          data-cy={`field-${index}-add-answer-button`}
        >
          <img
            src={addIcon}
            alt="add"
            draggable="false"
            className="add-answer"
          />
        </Button>
      </div>
      {newAnswerError && <div className="error">{newAnswerError}</div>}
      {answersError && <div className="error">{answersError}</div>}
    </Fragment>
  )
}

export default NextAnswer
